import { render, staticRenderFns } from "./PostaBase.vue?vue&type=template&id=97af8176&scoped=true&"
import script from "./PostaBase.vue?vue&type=script&lang=js&"
export * from "./PostaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97af8176",
  null
  
)

export default component.exports